import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isClientAndUser } from "../utils/clientStatus";

const PrivateRouteClientUser = ({ component: Component, ...rest }) => {
  let clientName = localStorage.getItem("clientname");

  return (
    <Route
      {...rest}
      render={(props) =>
        isClientAndUser() ? (
          <Component {...props}></Component>
        ) : (
          <Redirect to={`/${clientName}`}></Redirect>
        )
      }
    ></Route>
  );
};

export default PrivateRouteClientUser;
